import { render } from "./BaseButton.vue?vue&type=template&id=1145853d"
import script from "./BaseButton.vue?vue&type=script&lang=ts"
export * from "./BaseButton.vue?vue&type=script&lang=ts"

import "./BaseButton.vue?vue&type=style&index=0&id=1145853d&lang=scss"
script.render = render

export default script